import Button from '../../components/base/Button';
import { useRemainingMaterialSummary } from '../../features/jobs/hooks/useProductionDashboardStats';
import OrdersCopperReviewChart from '../charts/production-management-charts/ProductionOrdersCopperReviewChart';
import { Col, Row, Spinner, Alert } from 'react-bootstrap';
import { formatMass, exactMass } from '../../helpers/formatMass';

const bulletColors = [
  'info-300',
  'warning-300',
  'danger-300',
  'success-300',
  'primary',
  'secondary',
  'info',
  'warning',
  'success'
];

const prettyWireType = wireType => {
  const t = String(wireType || '')
    .trim()
    .toUpperCase();
  if (t === 'SINGLE-WIRE') return 'Solid Copper';
  if (t === 'STRANDED') return 'Stranded Copper';
  if (t === 'MULTI-WIRE') return 'Multi-Wire Copper';
  return 'Copper';
};



const OrdersCopperReview = () => {
  const { data, isLoading, isError, error } = useRemainingMaterialSummary();

  const reviewStats = (data?.copperByDiameter || []).map((item, index) => ({
    // wireDiameter is the strand Ø in mm (e.g. flexible MYYM = 0.25 mm strands),
    // NOT a quantity — label it as a diameter so it can't be misread.
    type: item.wireDiameter
      ? `${prettyWireType(item.wireType)} · Ø${item.wireDiameter} mm`
      : prettyWireType(item.wireType),
    value: Number(item.planned_kg || 0),
    bg: bulletColors[index % bulletColors.length]
  }));

  const totalKg = reviewStats.reduce((sum, item) => sum + item.value, 0);

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <h3 className="text-1100 text-nowrap">Copper Required</h3>
        <p className="text-700 mb-md-7">
          Remaining copper needed for unplanned orders
        </p>

        {isLoading ? (
          <div className="d-flex align-items-center py-4">
            <Spinner animation="border" size="sm" className="me-2" />
            <span>Loading copper requirements...</span>
          </div>
        ) : isError ? (
          <Alert variant="danger" className="mb-0">
            Failed to load copper summary: {error?.message || 'Unknown error'}
          </Alert>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold">Issue type </p>
              <p className="mb-0 fs-9">
                Total count{' '}
                <span className="fw-bold" title={exactMass(totalKg)}>
                  {formatMass(totalKg)}
                </span>
              </p>
            </div>

            <hr className="bg-200 mb-2 mt-2" />

            {reviewStats.length ? (
              reviewStats.map(issue => (
                <div
                  className="d-flex align-items-center mb-1"
                  key={issue.type}
                >
                  <span
                    className={`d-inline-block bg-${issue.bg} bullet-item me-2`}
                  />
                  <p className="mb-0 fw-semi-bold text-900 lh-sm flex-1">
                    {issue.type}
                  </p>
                  <h5 className="mb-0 text-900" title={exactMass(issue.value)}>
                    {formatMass(issue.value)}
                  </h5>
                </div>
              ))
            ) : (
              <p className="text-700 mb-0">No copper requirement found</p>
            )}

            <Button variant="outline-primary" className="mt-5" disabled>
              See Details
            </Button>
          </>
        )}
      </Col>

      <Col xs={12} md={6}>
        <div className="position-relative mb-sm-4 mb-xl-0">
          <OrdersCopperReviewChart />
        </div>
      </Col>
    </Row>
  );
};

export default OrdersCopperReview;
